import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import {Grid, withStyles} from '@material-ui/core';
import LoadingIndicator from "../common/LoadingIndicator";
import Paper from '@material-ui/core/Paper';
import {injectIntl} from "react-intl";

const styles = theme => ({
    button: {
        margin: 0,
    },
    root: {
        padding: '24px',
        background: '#f1f1f1'
    },
    paper: {
        padding: '24px',
    }
});
const gridSize = {
    xs: 12,
    sm: 10,
    md: 8,
    lg: 6,
};

class Rules extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false
        };
    }

    componentWillMount() {
        document.title = this.props.intl.formatMessage({id: 'common.rules'});
    }

    render() {
        const {classes} = this.props;
        if (this.state.isLoading) {
            return (
                <div className={classes.root}>
                    <LoadingIndicator/>
                </div>)
        } else {
            return (
                <div className={classes.root}>
                    <Grid container item spacing={0} justify="center">
                        <Grid item {...gridSize}>
                            <Paper className={classes.paper} elevation={2}>
                                <div>
                                    <h3>Пользовательское Соглашение</h3>Настоящее Пользовательское Соглашение (Далее
                                    Соглашение) регулирует отношения между владельцем grafeo.app (далее Grafeo или
                                    Администрация) с одной стороны и пользователем сайта с другой.<br/>Сайт Grafeo не
                                    является средством массовой информации.<br/><br/>Используя сайт, Вы соглашаетесь с
                                    условиями данного соглашения.<br/><b>Если Вы не согласны с условиями данного
                                    соглашения, не используйте сайт Grafeo!</b><br/><br/><h3>Права и обязанности
                                    сторон</h3><b>Пользователь имеет право:</b><br/>- получать информацию на сайте<br/>-
                                    создавать информацию для сайта<br/>- требовать от администрации скрытия любой
                                    информации о пользователе<br/>- требовать от администрации скрытия любой информации
                                    переданной пользователем сайту<br/>- использовать информацию сайта в личных
                                    некоммерческих целях<br/><br/><b>Администрация имеет право:</b><br/>- по своему
                                    усмотрению и необходимости создавать, изменять, отменять правила<br/>- ограничивать
                                    доступ к любой информации на сайте<br/>- создавать, изменять, удалять
                                    информацию<br/>- удалять учетные записи<br/><br/><b>Пользователь обязуется:</b><br/>-
                                    не нарушать работоспособность сайта<br/>- не использовать скрипты (программы) для
                                    автоматизированного сбора информации и/или взаимодействия с Сайтом и его
                                    Сервисами<br/><br/><b>Администрация обязуется:</b><br/>- поддерживать
                                    работоспособность сайта за исключением случаев, когда это невозможно по независящим
                                    от Администрации причинам.<br/><br/><h3>Ответственность сторон</h3>- администрация
                                    не несёт ответственность за несовпадение ожидаемых Пользователем и реально
                                    полученных услуг<br/>- администрация не несет никакой ответственности за услуги,
                                    предоставляемые третьими лицами<br/>- в случае возникновения форс-мажорной ситуации
                                    (боевые действия, чрезвычайное положение, стихийное бедствие и т. д.) Администрация
                                    не гарантирует сохранность информации, размещённой Пользователем, а также
                                    бесперебойную работу информационного ресурса<br/><br/><h3>Условия действия
                                    Соглашения</h3>Данное Соглашение вступает в силу при любом использовании данного
                                    сайта.<br/>Соглашение перестает действовать при появлении его новой версии.<br/>Администрация
                                    оставляет за собой право в одностороннем порядке изменять данное соглашение по
                                    своему усмотрению.<br/>Администрация не оповещает пользователей об изменении в
                                    Соглашении.<br/><br/><br/>
                                </div>
                            </Paper>
                        </Grid>
                    </Grid>
                </div>)
        }

    }
}

export default injectIntl(withRouter(withStyles(styles)(Rules)));
